import React from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const EditMenu = ({ onEditClick }) => {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#e0e7ff',
        padding: '6px',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(37, 99, 235, 0.3)',
        transition: 'background-color 0.3s ease',
      }}
      title="Edit"
      onClick={onEditClick}
      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#c7d2fe'}
      onMouseLeave={e => e.currentTarget.style.backgroundColor = '#e0e7ff'}
    >
      <EditOutlinedIcon fontSize="small" sx={{ color: '#2563eb' }} />
    </span>
  );
};

export default EditMenu;
